import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from 'react';
import { Button } from '@instructure/ui-buttons';
import { IconRefreshLine } from '@instructure/ui-icons';
import t from '@instructure/quiz-i18n/format-message';
import PropTypes from 'prop-types';
export function RetryGradePassbackButton(_ref) {
  var addAlert = _ref.addAlert,
    onClick = _ref.onClick,
    dataAutomation = _ref['data-automation'];
  var _React$useState = React.useState('idle'),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    retryGradePassbackStatus = _React$useState2[0],
    setRetryGradePassbackStatus = _React$useState2[1];
  function handleClick() {
    return _handleClick.apply(this, arguments);
  }
  function _handleClick() {
    _handleClick = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(retryGradePassbackStatus === 'pending')) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            _context.prev = 2;
            setRetryGradePassbackStatus('pending');
            _context.next = 6;
            return onClick();
          case 6:
            response = _context.sent;
            if (!(response == null)) {
              _context.next = 9;
              break;
            }
            throw new Error('Failed to retry grade passback');
          case 9:
            addAlert({
              message: t('Grade passback has been retried. This may take a while.'),
              variant: 'info',
              removeIn: 5000
            });
            setRetryGradePassbackStatus('success');
            _context.next = 17;
            break;
          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](2);
            addAlert({
              message: t('Failed to retry grade passback. Please try again.'),
              variant: 'error',
              removeIn: 5000
            });
            setRetryGradePassbackStatus('error');
          case 17:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 13]]);
    }));
    return _handleClick.apply(this, arguments);
  }
  return /*#__PURE__*/React.createElement(Button, {
    renderIcon: IconRefreshLine,
    onClick: handleClick,
    disabled: retryGradePassbackStatus === 'pending',
    "data-automation": dataAutomation
  }, t('Retry Grade Passback'));
}
RetryGradePassbackButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  addAlert: PropTypes.func.isRequired,
  'data-automation': PropTypes.string
};